export const AlgoSVG = () => (
    <svg
        className="algo-icon"
        width={12}
        height={12}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.76731 3.468H10.3633L9.28531 5.358L10.9513 11.588H9.59331L8.33331 6.996L5.65931 11.588H4.17531L7.84331 5.19L7.08731 2.348L1.76731 11.588H0.255313L6.55531 0.681999H8.01131L8.76731 3.468Z"
            fill="#ffffff"
        />
    </svg>
);

export const PeraNormalSVG = () => (
    <svg
        className="pera-logo"
        width={80}
        height={30}
        viewBox="0 0 80 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#a)">
            <path
                d="M18.473 6.737c.567 2.352.375 4.42-.429 4.62s-1.916-1.543-2.484-3.895-.376-4.42.428-4.62c.805-.2 1.917 1.543 2.485 3.895m9.372 2.023c-1.257-1.333-3.758-.972-5.585.806-1.829 1.777-2.291 4.299-1.034 5.631s3.758.971 5.586-.807c1.828-1.777 2.29-4.299 1.033-5.63m-9.997 20.4c.804-.2.968-2.386.365-4.882s-1.743-4.357-2.547-4.157c-.805.2-.968 2.385-.366 4.882.603 2.496 1.743 4.357 2.547 4.157M9.648 9.979c2.32.684 4.017 1.885 3.788 2.681-.23.797-2.296.888-4.616.204-2.32-.685-4.016-1.885-3.788-2.682.23-.796 2.296-.887 4.616-.203m15.062 8.995c2.462.726 4.273 1.96 4.044 2.758-.229.796-2.41.853-4.873.127-2.463-.727-4.274-1.961-4.046-2.758.23-.796 2.411-.853 4.874-.127M12.26 17.303c-.576-.597-2.463.271-4.216 1.939-1.753 1.667-2.708 3.502-2.132 4.099.575.596 2.463-.272 4.216-1.94 1.752-1.666 2.707-3.502 2.131-4.098m29.85-6.485v-.514H40V24h2.109v-3.69c0-.4 0-.723-.039-1.16h.039c.766 1.255 2.07 1.92 3.603 1.92 2.588 0 4.85-1.959 4.85-5.592 0-3.557-2.262-5.478-4.85-5.478-1.476 0-2.78.647-3.603 1.921h-.039c.039-.418.039-.723.039-1.103m3.067 8.446c-1.956-.02-3.087-1.674-3.087-3.805 0-2.016 1.131-3.633 3.087-3.652 1.916-.019 3.182 1.465 3.182 3.671 0 2.264-1.266 3.805-3.182 3.786m16.458-4.68c0-2.625-2.108-4.584-4.983-4.584-3.068 0-5.195 2.073-5.195 5.535 0 3.33 2.09 5.536 5.194 5.536 2.55 0 4.448-1.484 4.889-3.52h-2.3c-.365 1.028-1.362 1.713-2.588 1.713-1.572 0-2.723-1.123-2.972-2.987h7.955zm-4.983-2.777c1.552 0 2.626 1.065 2.856 2.606h-5.808c.268-1.484 1.36-2.606 2.952-2.606m6.534 8.959h2.108V14.87c0-2.017 1.112-3.063 2.837-3.063h1.131V10h-.9c-1.554 0-2.512 1.027-3.068 1.921h-.038v-1.617h-2.07zm15.933-1.826c-.287 0-.421-.171-.421-.513v-4.604c0-2.206-1.074-3.823-4.237-3.823-3.067 0-4.466 1.522-4.62 3.69h2.11c.133-1.18 1.073-1.883 2.51-1.883 1.227 0 2.07.533 2.07 1.37 0 .684-.479 1.103-2.05 1.103h-.844c-2.511 0-4.198 1.008-4.198 3.31 0 2.415 1.783 3.519 3.872 3.519 1.553 0 2.875-.685 3.393-2.15.057 1.066.767 1.807 2.108 1.807H80V18.94zm-2.53-3.043c0 2.358-1.284 3.386-2.933 3.386-1.437 0-2.013-.837-2.013-1.693 0-.818.499-1.484 2.032-1.484h.307c1.476 0 2.396-.514 2.588-1.408h.019z"
                fill="#26262B"
            />
            <rect width={30} height={30} rx={9.871} fill="#26262B" />
            <path
                d="M16.064 8.672c.382 1.607.253 3.02-.289 3.157-.541.136-1.29-1.055-1.673-2.662-.382-1.606-.252-3.02.29-3.156.54-.137 1.29 1.055 1.672 2.661m6.311 1.381c-.847-.91-2.53-.663-3.761.551-1.231 1.215-1.543 2.937-.697 3.847.847.91 2.53.664 3.762-.55 1.23-1.215 1.542-2.937.696-3.848M15.643 23.99c.541-.137.652-1.63.246-3.335s-1.174-2.977-1.715-2.84-.652 1.63-.246 3.335c.405 1.705 1.173 2.977 1.715 2.84m-5.521-13.103c1.563.467 2.704 1.287 2.55 1.831-.154.545-1.546.607-3.108.14-1.562-.468-2.704-1.288-2.55-1.832.154-.545 1.546-.607 3.108-.14m10.141 6.146c1.659.496 2.878 1.34 2.724 1.883-.154.545-1.624.584-3.282.087-1.658-.496-2.878-1.34-2.724-1.883.154-.545 1.624-.584 3.282-.087M11.88 15.89c-.387-.408-1.658.185-2.838 1.325s-1.823 2.392-1.436 2.8c.388.407 1.658-.186 2.839-1.325 1.18-1.139 1.823-2.393 1.435-2.8"
                fill="#fff"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h80v30H0z" />
            </clipPath>
        </defs>
    </svg>
);

export const PeraSVG = () => (
    <svg
        width={80}
        height={30}
        viewBox="0 0 80 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_14011_119165)">
            <path
                d="M42.1086 10.8179V10.3043H40V24H42.1086V20.3098C42.1086 19.9103 42.1086 19.587 42.0702 19.1495H42.1086C42.8753 20.4049 44.1788 21.0707 45.7123 21.0707C48.3001 21.0707 50.562 19.1114 50.562 15.4783C50.562 11.9212 48.3001 10 45.7123 10C44.2363 10 42.9328 10.6467 42.1086 11.9212H42.0702C42.1086 11.5027 42.1086 11.1984 42.1086 10.8179ZM45.1756 19.2636C43.2204 19.2446 42.0894 17.5897 42.0894 15.4592C42.0894 13.4429 43.2204 11.8261 45.1756 11.8071C47.0924 11.788 48.3576 13.2717 48.3576 15.4783C48.3576 17.7418 47.0924 19.2826 45.1756 19.2636Z"
                className="dark:fill-white fill-[#26262B]"
            />
            <path
                d="M61.6344 14.5842C61.6344 11.9592 59.5258 10 56.6505 10C53.5835 10 51.4557 12.0734 51.4557 15.5353C51.4557 18.8641 53.5451 21.0707 56.6505 21.0707C59.1999 21.0707 61.0976 19.587 61.5385 17.5516H59.2383C58.8741 18.5788 57.8773 19.2636 56.6505 19.2636C55.0786 19.2636 53.9285 18.1413 53.6793 16.2772H61.6344V14.5842ZM56.6505 11.8071C58.2032 11.8071 59.2766 12.8723 59.5066 14.413H53.6985C53.9669 12.9293 55.0595 11.8071 56.6505 11.8071Z"
                className="dark:fill-white fill-[#26262B]"
            />
            <path
                d="M63.1845 20.7663H65.2931V14.8696C65.2931 12.8533 66.4048 11.8071 68.13 11.8071H69.261V10H68.3601C66.8074 10 65.8489 11.0272 65.2931 11.9212H65.2547V10.3043H63.1845V20.7663Z"
                className="dark:fill-white fill-[#26262B]"
            />
            <path
                d="M79.1182 18.9402C78.8307 18.9402 78.6965 18.769 78.6965 18.4266V13.8234C78.6965 11.6168 77.6231 10 74.4602 10C71.3932 10 69.9939 11.5217 69.8405 13.6902H71.9491C72.0833 12.5109 73.0226 11.8071 74.4602 11.8071C75.687 11.8071 76.5305 12.3397 76.5305 13.1766C76.5305 13.8614 76.0512 14.2799 74.4794 14.2799H73.636C71.1249 14.2799 69.438 15.288 69.438 17.5897C69.438 20.0054 71.2207 21.1087 73.3101 21.1087C74.8628 21.1087 76.1854 20.4239 76.703 18.9592C76.7605 20.0245 77.4697 20.7663 78.8115 20.7663H80V18.9402H79.1182ZM76.588 15.8967C76.588 18.2554 75.3036 19.2826 73.6551 19.2826C72.2175 19.2826 71.6424 18.4457 71.6424 17.5897C71.6424 16.7717 72.1408 16.106 73.6743 16.106H73.981C75.457 16.106 76.3771 15.5924 76.5688 14.6984H76.588V15.8967Z"
                className="dark:fill-white fill-[#26262B]"
            />
            <rect width={30} height={30} rx={9.8707} className="dark:fill-[#AC8EFF] fill-[#26262B]" />
            <path
                d="M16.0637 8.67213C16.4459 10.2787 16.3167 11.6919 15.7752 11.8286C15.2336 11.9653 14.4847 10.7737 14.1025 9.16714C13.7203 7.56057 13.8495 6.14737 14.3911 6.01068C14.9327 5.87399 15.6815 7.06556 16.0637 8.67213Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
            <path
                d="M22.3748 10.0534C21.5284 9.14325 19.8444 9.38994 18.6136 10.6044C17.3827 11.8189 17.0711 13.5412 17.9175 14.4513C18.7639 15.3615 20.4479 15.1148 21.6788 13.9003C22.9096 12.6859 23.2213 10.9635 22.3748 10.0534Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
            <path
                d="M15.6428 23.9899C16.1844 23.8532 16.2946 22.3601 15.8889 20.6549C15.4833 18.9497 14.7154 17.6782 14.1738 17.8149C13.6322 17.9516 13.5221 19.4447 13.9277 21.1499C14.3334 22.8551 15.1013 24.1266 15.6428 23.9899Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
            <path
                d="M10.1221 10.8866C11.6845 11.3541 12.8262 12.1742 12.6721 12.7184C12.518 13.2626 11.1265 13.3248 9.564 12.8573C8.00153 12.3899 6.85983 11.5697 7.01394 11.0256C7.16804 10.4814 8.5596 10.4192 10.1221 10.8866Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
            <path
                d="M20.2631 17.0316C21.9215 17.5278 23.141 18.3712 22.9869 18.9154C22.8328 19.4596 21.3634 19.4985 19.7051 19.0023C18.0467 18.5062 16.8272 17.6628 16.9813 17.1186C17.1355 16.5744 18.6048 16.5355 20.2631 17.0316Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
            <path
                d="M11.8802 15.8898C11.4927 15.4823 10.2218 16.0754 9.04156 17.2145C7.8613 18.3536 7.21861 19.6074 7.60607 20.0149C7.99354 20.4224 9.26444 19.8293 10.4447 18.6902C11.625 17.5511 12.2677 16.2973 11.8802 15.8898Z"
                className="dark:fill-[#1A1A1A] fill-white"
            />
        </g>
        <defs>
            <clipPath id="clip0_14011_119165">
                <rect width={80} height={30} fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const LockSVG = () => (
    <svg
        className="lock-icon"
        width={16}
        height={16}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 6.24777C7.5 3.40727 9.68308 1 12.5 1C15.3169 1 17.5 3.40727 17.5 6.24777V9H18.2143C20.0183 9 21.5 10.4495 21.5 12.2633V19.7367C21.5 21.5476 20.019 23 18.2143 23H6.78571C4.98103 23 3.5 21.5476 3.5 19.7367V12.2633C3.5 10.4524 4.98103 9 6.78571 9H7.5V6.24777ZM6.78571 11C6.06697 11 5.5 11.5755 5.5 12.2633V19.7367C5.5 20.4245 6.06697 21 6.78571 21H18.2143C18.933 21 19.5 20.4245 19.5 19.7367V12.2633C19.5 11.5739 18.9337 11 18.2143 11H6.78571ZM15.5 9H9.5V6.24777C9.5 4.3969 10.8992 3 12.5 3C14.1008 3 15.5 4.3969 15.5 6.24777V9Z"
            fill="#3C3C49"
        />
    </svg>
);

export const HomeSVG = () => (
    <svg
        className="home-icon"
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9778 1.01869C13.0563 0.993403 14.1881 1.26666 15.0935 1.90044L21.2718 6.22927C21.2721 6.22951 21.2725 6.22974 21.2728 6.22998C21.9339 6.69104 22.4793 7.39185 22.8577 8.11692C23.2365 8.84243 23.5 9.69172 23.5 10.4997V17.7797C23.5 20.6404 21.1638 22.9897 18.29 22.9897H6.71C3.83463 22.9897 1.5 20.6389 1.5 17.7697V10.3597C1.5 9.6007 1.73837 8.79368 2.07974 8.09793C2.42127 7.40185 2.91433 6.71838 3.51589 6.25045C3.51594 6.2504 3.51583 6.25049 3.51589 6.25045L8.90535 2.05087C9.77999 1.37059 10.8993 1.04398 11.9778 1.01869ZM10.1339 3.62902C10.1338 3.62911 10.1341 3.62893 10.1339 3.62902L4.74465 7.82847C4.44628 8.06053 4.1237 8.47255 3.87526 8.9789C3.62663 9.48565 3.5 9.98863 3.5 10.3597V17.7697C3.5 19.5405 4.94537 20.9897 6.71 20.9897H18.29C20.0562 20.9897 21.5 19.5389 21.5 17.7797V10.4997C21.5 10.0976 21.3585 9.5669 21.0848 9.04241C20.8109 8.51786 20.4567 8.09902 20.1282 7.87007L20.1262 7.86865L13.9465 3.5389C13.452 3.19283 12.7585 3.00094 12.0247 3.01814C11.2909 3.03535 10.6093 3.25946 10.1339 3.62902ZM12.5 13.9897C13.0523 13.9897 13.5 14.4375 13.5 14.9897V17.9897C13.5 18.542 13.0523 18.9897 12.5 18.9897C11.9477 18.9897 11.5 18.542 11.5 17.9897V14.9897C11.5 14.4375 11.9477 13.9897 12.5 13.9897Z"
            className="fill-[#6b45fe] dark:fill-[#ac8eff]"
        />
    </svg>
);

export const ShareSVG = () => (
    <svg
        className="share-icon"
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.793 1.793a1 1 0 0 1 1.415 0l3.35 3.35a1 1 0 0 1-1.415 1.414L13.5 4.914V15a1 1 0 1 1-2 0V4.915L9.858 6.557a1 1 0 0 1-1.415-1.414zm4.151 7.021a1 1 0 0 1 1.082-.91c1.95.167 3.524.771 4.576 2.068 1.03 1.27 1.409 3.021 1.409 5.138v.13c0 2.334-.462 4.228-1.747 5.513S18.084 22.5 15.75 22.5H9.24c-2.334 0-4.228-.461-5.514-1.747-1.285-1.285-1.747-3.18-1.747-5.513v-.13c0-2.101.374-3.842 1.387-5.108 1.036-1.296 2.588-1.909 4.51-2.088a1 1 0 1 1 .186 1.992c-1.617.15-2.56.628-3.134 1.345-.597.746-.949 1.94-.949 3.859v.13c0 2.136.434 3.372 1.161 4.099s1.963 1.16 4.1 1.16h6.51c2.136 0 3.371-.433 4.099-1.16.727-.727 1.16-1.963 1.16-4.1v-.13c0-1.932-.356-3.13-.961-3.876-.583-.719-1.544-1.195-3.194-1.337a1 1 0 0 1-.91-1.082"
            className="dark:fill-white fill-black"
        />
    </svg>
);

export const SettingSVG = () => (
    <svg
        className="settings-icon"
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m14.503 1.605.002.002L20 4.784l.06.037.03.02c.474.32.876.592 1.187.838.325.258.623.542.839.915.221.383.309.777.348 1.177.036.367.036.805.036 1.296v5.866c0 .49 0 .928-.036 1.296-.04.4-.127.793-.348 1.176-.216.373-.514.658-.839.915-.311.247-.713.518-1.187.838l-.03.02-.06.038-5.495 3.177-.002.001c-.6.351-1.328.496-2 .496s-1.4-.146-2.004-.494L5 19.216l-.058-.037-.031-.021c-.474-.32-.876-.591-1.187-.838-.326-.258-.624-.543-.84-.917-.22-.384-.308-.778-.347-1.179-.036-.368-.036-.808-.036-1.301V9.067c0-.49 0-.929.036-1.296.04-.4.127-.794.348-1.177.216-.373.514-.657.839-.915a21 21 0 0 1 1.187-.837l.03-.021.06-.037 5.5-3.18c.602-.349 1.331-.494 2.004-.494.67 0 1.398.145 1.999.495m-2 1.505c-.414 0-.776.094-1.002.226L6.03 6.498a19 19 0 0 0-1.066.75c-.238.187-.315.288-.35.347-.028.05-.065.136-.089.372-.025.257-.026.596-.026 1.143v5.77c0 .55.001.89.027 1.15.023.237.06.324.09.374.034.06.11.16.348.349.24.19.569.413 1.066.749l5.47 3.162c.226.131.588.226 1.003.226s.772-.095.99-.223l.005-.003 5.47-3.162c.497-.336.826-.56 1.066-.75.238-.188.315-.288.35-.348.028-.049.065-.135.089-.371.025-.258.026-.596.026-1.143V9.11c0-.547-.001-.886-.026-1.143-.024-.236-.061-.322-.09-.372-.034-.06-.111-.16-.349-.348-.24-.19-.569-.413-1.066-.749l-5.474-3.165c-.22-.128-.576-.223-.991-.223M12.5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
            className="dark:fill-white fill-black"
        />
    </svg>
);

export const TwitterSVG = () => (
    <svg
        className="twitter-icon"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.703 4.32a7.8 7.8 0 0 1-2.23.612 3.9 3.9 0 0 0 1.707-2.149 7.8 7.8 0 0 1-2.465.942A3.883 3.883 0 0 0 10.1 7.267a11.02 11.02 0 0 1-8-4.057 3.883 3.883 0 0 0 1.2 5.183 3.9 3.9 0 0 1-1.759-.486v.05a3.885 3.885 0 0 0 3.114 3.807 3.9 3.9 0 0 1-1.753.067 3.88 3.88 0 0 0 3.627 2.695 7.8 7.8 0 0 1-4.822 1.662q-.47 0-.927-.054a11 11 0 0 0 5.95 1.744c7.142 0 11.046-5.915 11.046-11.045q0-.25-.012-.501A7.9 7.9 0 0 0 19.7 4.323z"
            fill="#BCBCC8"
        />
    </svg>
);

export const DiscordSVG = () => (
    <svg
        className="discord-icon"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.074 4.797a15 15 0 0 0-3.61-1.047c-.156.26-.337.608-.463.886a14.4 14.4 0 0 0-4.001 0 9 9 0 0 0-.468-.886c-1.268.202-2.48.56-3.613 1.05-2.285 3.185-2.904 6.292-2.595 9.355a14.9 14.9 0 0 0 4.428 2.094q.537-.68.949-1.441a9.7 9.7 0 0 1-1.494-.671q.188-.129.366-.267c2.88 1.242 6.009 1.242 8.854 0q.18.138.366.267a9.6 9.6 0 0 1-1.496.672q.41.76.948 1.441a14.9 14.9 0 0 0 4.43-2.095c.364-3.55-.62-6.629-2.6-9.358M7.093 12.27c-.864 0-1.573-.744-1.573-1.65 0-.908.693-1.654 1.573-1.654s1.588.745 1.573 1.653c.002.907-.694 1.651-1.573 1.651m5.814 0c-.864 0-1.573-.744-1.573-1.65 0-.908.693-1.654 1.573-1.654s1.588.745 1.573 1.653c0 .907-.694 1.651-1.573 1.651"
            fill="#BCBCC8"
        />
    </svg>
);

export const RedditSVG = () => (
    <svg
        className="reddit-icon"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.166 9.3c0-1.137-.903-2.04-2.004-2.04-.542 0-1.035.217-1.396.568-1.38-1.004-3.27-1.656-5.372-1.74l.92-4.384 2.99.652a1.44 1.44 0 0 0 1.429 1.39c.788 0 1.43-.653 1.43-1.457 0-.803-.642-1.456-1.43-1.456-.559 0-1.051.335-1.281.82l-3.335-.72a.35.35 0 0 0-.263.051.33.33 0 0 0-.148.234L9.688 6.105c-2.136.067-4.058.72-5.454 1.74a2 2 0 0 0-1.397-.57c-1.117 0-2.004.921-2.004 2.042 0 .837.493 1.54 1.183 1.858-.033.2-.05.401-.05.619C1.967 14.94 5.565 17.5 10 17.5s8.033-2.543 8.033-5.706c0-.2-.017-.418-.05-.62a2.06 2.06 0 0 0 1.183-1.873M5.4 10.758c0-.804.64-1.456 1.43-1.456.788 0 1.428.652 1.428 1.456s-.64 1.455-1.429 1.455c-.788.017-1.43-.652-1.43-1.455m8 3.865c-.985 1.004-2.858 1.07-3.4 1.07-.559 0-2.432-.083-3.4-1.07a.38.38 0 0 1 0-.536.36.36 0 0 1 .525 0c.624.636 1.938.854 2.875.854.936 0 2.267-.218 2.874-.854a.36.36 0 0 1 .526 0 .41.41 0 0 1 0 .536m-.263-2.393c-.788 0-1.429-.652-1.429-1.456s.64-1.456 1.43-1.456c.788 0 1.429.653 1.429 1.456 0 .787-.641 1.456-1.43 1.456"
            fill="#BCBCC8"
        />
    </svg>
);

export const RightArrowSVG = () => (
    <svg
        className="arrow-right-icon"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.793 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L17.086 13H5.5a1 1 0 1 1 0-2h11.586l-3.293-3.293a1 1 0 0 1 0-1.414"
            className="fill-[#6b45fe] dark:fill-[#ac8eff]"
        />
    </svg>
);

export const LeftArrowSVG = () => (
    <svg
        className="arrow-left-icon ms-2"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.207 6.293a1 1 0 0 1 0 1.414L7.914 11H19.5a1 1 0 1 1 0 2H7.914l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0"
            fill="currentColor"
        />
    </svg>
);

export const LoadingSVG = () => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-spin"
    >
        <path
            d="M12 1v4"
            stroke="#DF1463"
            strokeWidth={1.7}
            strokeLinecap="round"
        />
        <path
            d="m19.425 18.925-2.829-2.829M22.5 11.5h-4M12 18v4M7.404 6.904 4.575 4.075M5.5 11.5h-4m5.904 4.596-2.829 2.829"
            stroke="#6b45fe"
            strokeWidth={1.7}
            strokeLinecap="round"
        />
    </svg>
);